<script setup>
import {computed, onMounted, ref} from "vue";
import axios from "@/axios";
import {useComStore, useLanguageStore} from "@/pinia";
const languageStore = useLanguageStore();
const committees= ref([])
const selectedMenu = ref("mt000");
const props = defineProps(['codeId'])
const emits = defineEmits(['set_menu'])
const useComCode = useComStore();

const computedCommittees = computed(()=>{
  if(committees.value.length <1) return
  return [{"codeId" : "mt000", "codeNm" : languageStore.get('recentMeetings')} , ...committees.value]
})

const selectMenu=(e)=>{
  const target = e.target.dataset.id;
  const recordVideoMenuArea = document.getElementById("recordVideoMenuArea").children;
  for(let i=0 ; i<recordVideoMenuArea.length ;i++){
    recordVideoMenuArea[i].classList.replace("selectedSubMenu","subMenu");
  }
  e.target.classList.replace("subMenu","selectedSubMenu");
  selectedMenu.value = target
  emits('set_menu', target);
}
onMounted(()=>{
  committees.value = useComCode.getCodeType('meetingType');

})
</script>

<template>
  <div class="recordVideoMenuArea" id="recordVideoMenuArea">
    <template v-for="(menu,i) in computedCommittees" :key="i">
      <template v-if="selectedMenu == menu.codeId">
        <div @click="selectMenu" class="selectedSubMenu" :data-id="menu.codeId">{{menu.codeNm}}</div>
      </template>
      <template v-else>
        <div @click="selectMenu" class="subMenu" :data-id="menu.codeId">{{menu.codeNm}}</div>
      </template>
    </template>
  </div>
</template>

<style scoped>
  .recordVideoMenuArea{
    display: flex;
    align-items: center;
    height: 8vh;
    width : 100%;
    margin: 10px 0 0 0;
    border-bottom: 1px solid #C7C7C7;
  }

  .subMenu{
    width: 130px;
    font-size: 1.1rem;
    display: flex;
    padding: 5px;
    justify-content: center;
    cursor: pointer;
  }
  .subMenu:hover ,.selectedSubMenu{
    width: 130px;
    font-size: 1.2rem;
    font-weight: bold;
    display: flex;
    padding: 5px;
    justify-content: center;
    align-items: center;
    color : #09223F;
    height: 100%;
    border-bottom: 1px solid #09223F;
  }

</style>